export const YM_COUNTER_ID = Number(process.env.REACT_APP_YM_COUNTER_ID);

const isReady = () => Boolean(YM_COUNTER_ID) && typeof window.ym === 'function';

// Просмотр страницы. Счётчик сам не отслеживает переходы History API,
// поэтому в SPA хит на каждый новый маршрут отправляем руками.
export const ymHit = (url, referer) => {
  if (!isReady()) return;
  window.ym(YM_COUNTER_ID, 'hit', url, { referer });
};

export const ymReachGoal = (target, params) => {
  if (!isReady()) return;
  window.ym(YM_COUNTER_ID, 'reachGoal', target, params);
};
